export const roles = {
    admin: 'admin',
    user: 'user',
    legal: 'legal',
    legal_admin: 'legal_admin',
    regional_manager_admin: 'regional_manager_admin',
    pricing_analyst: 'pricing_analyst',
    executive_assistant: 'executive_assistant'
};

